<template>
  <modal
    :header="true"
    :footer="true"
    :transition-name="transitionName"
    :close-button="true"
    disable-click-outside
    class="shoppable-modal"
    data-test="graphics-shoppableContentModal"
    auto-height
    @close="onCancel"
  >
    <template
      v-if="hasShoppable" #modal-header
    >
      <h2>Shoppable</h2>
    </template>
    <template
      v-if="hasShoppable" #modal-body
    >
      <p class="shoppable-modal__description">
        Select the content you want to display.
      </p>
      <p class="legal-alert alert alert-info">
        The legal disclosure and QR code are required for shoppable content.
      </p>
      <div class="shoppable-modal__types">
        <label
          v-for="({ title, description, disabled, value, icon }, index) in shoppableOptions"
          :key="value"
          class="shoppable-modal__types-option"
        >
          <input
            :id="value"
            v-model="shoppableOptions[index].checked"
            type="checkbox"
            name="social-type"
            :data-test="`graphics-shoppableModal-select${upperFirst(value)}`"
            :data-entity="`graphics-shoppableModal-select${upperFirst(value)}`"
            :value="value"
            class="hidden-checkbox"
            tabindex="0"
            :disabled="disabled"
          >
          <span class="checkbox-icon" />
          <span :class="icon" />
          <span class="shoppable-modal__option-content">
            <div class="shoppable-modal__radio-title">
              {{ title }}
            </div>
            <div
              v-if="description"
              class="shoppable-modal__input-description"
            >
              {{ description }}
            </div>
          </span>
        </label>
      </div>
    </template>
    <template
      v-if="hasShoppable" #modal-footer
    >
      <button
        class="btn btn-style-a no-tooltip"
        :data-test="`graphics-addShoppableTemplate`"
        :data-entity="`graphics-addShoppableTemplate`"
        @click="sendSelections"
      >
        Add Shoppable
      </button>
    </template>
    <template
      v-if="!hasShoppable" #modal-body
    >
      <div class="shoppable-modal__disabled">
        <h2>So You Want Shoppable?</h2>
        <p class="shoppable-modal__disabled-text">
          Great! We can help you.
        </p>
        <p class="shoppable-modal__disabled-text">
          <a
            href="https://landing.tagboard.com/shoppable"
            target="_blank"
            rel="noopener noreferrer"
          >
            Let's Get Started!
          </a>
        </p>
      </div>
    </template>
  </modal>
</template>

<script>
import { upperFirst } from 'lodash-es';
import { mapGetters } from 'vuex';
import Modal from './Modal.vue';
import { shoppableModalOptions } from '../../utils/shoppableConfigs';

export default {
  emits: ['close', 'select'],
  components: {
    Modal,
  },
  data() {
    return {
      transitionName: 'modal-form__slide',
      shoppableOptions: shoppableModalOptions,
    };
  },
  computed: {
    ...mapGetters([
      'hasShoppable',
    ]),

    selectedOptions() {
      return this.shoppableOptions.filter((option) => option.checked).map((option) => option.value);
    },
  },
  methods: {
    upperFirst,
    onCancel() {
      this.$emit('close');
    },
    sendSelections() {
      this.$emit('select', this.selectedOptions);
      this.$emit('close');
    },
  },
};
</script>

<style lang="scss" scoped>
.shoppable-modal {
  .legal-alert {
      position: absolute;
      margin: 0;
      height: 150px;
      width: 100%;
      left: 0px;
      padding: 1rem 2rem;
  }

  &__description {
    font-size: 14px;
    font-weight: normal;
  }

  &__types {
      position: relative;
      margin-top: 60px;
  }
  &__types-option {
    display: grid;
    grid-template-columns: 0fr 0.5fr 1.75fr 7fr;
    align-items: center;
    margin-bottom: 20px;
    justify-content: space-evenly;
    cursor: pointer;
    font-size: 16px;
    user-select: none;

    &:last-child {
      margin-bottom: 0;
    }

    /* Hide the default checkbox */
    .hidden-checkbox {
      opacity: 0;
      width: 0;
    }

    /* Style the custom checkbox icon */
    .checkbox-icon {
      position: relative;
      width: 14px;
      height: 14px;
      border: 2px solid #cbcbcb;
      background-color: transparent;
      margin-left: 3px;
      transition: border-color 0.3s ease, background-color 0.3s ease;
    }

    & input[type='checkbox']:checked + .checkbox-icon {
      border-color: #2288a0;
      background-color: #2288a0;
      box-shadow: 0 0 5px #2288a0;
      outline: 2px solid #2288a0;

      &::after {
          content: '';
          position: absolute;
          left: 3px;
          width: 5px;
          height: 10px;
          border: solid white;
          border-width: 0 3px 3px 0;
          -webkit-transform: rotate(45deg);
          -ms-transform: rotate(45deg);
          transform: rotate(45deg);
      }
    }
    // add focus state
    & input[type='checkbox']:focus + .checkbox-icon {
      outline: none;
      border-color: #2288a0;
    }
    /* Style the label text */
    &:hover .checkbox-icon {
      border-color: #036076; /* Border color on hover */
    }

    /* Remove default checkbox button outline on focus */
    & input[type='checkbox']:focus + .checkbox-icon {
      outline: none;
    }

    .fas {
      font-size: 35px;
      text-align: center;
    }
  }

  &__radio-title {
    font-size: 15px;
    font-weight: bold;
  }

  &__input-description {
    font-size: 12px;
    font-weight: normal;
    margin-top: 0.5rem;
    line-height: 1.3;
    display: block;
  }

  &__label-special {
    font-size: 12px;
    font-style: italic;
    font-weight: 400;
    color: #2288a0;
  }

  &.modal-footer {
    position: absolute;
    display: flex;
    flex-direction: row;
    width: 100%;
    bottom: 0;
    left: 0;
    padding: 2rem;
    justify-content: end;
    align-items: center;

    button {
      margin-left: 1rem;
    }
    .btn-style-a {
      background-color: #2bacca;
      border: 2px solid #2bacca;
      border-radius: 2px;
      padding: 10px 15px;
      font-size: 14px;
      font-weight: 700;
      color: white;

      &:hover {
        background-color: #2288a0;
        border-color: #2288a0;
      }
    }
  }

  &__disabled {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    height: 100%;

    &-text {
      font-size: 16px;
      text-align: center;
    }
  }
}
</style>
